/** Bridge 用户可见文案的中英文解析。 */

export type BridgeLocale = 'zh' | 'en';

/** OD Locale（如 zh-CN / en）→ Bridge 约定的 zh | en */
export function toBridgeLocale(locale?: string | null): BridgeLocale {
  if (!locale) return resolveBridgeLocale();
  const normalized = locale.trim().toLowerCase();
  if (normalized === 'en' || normalized.startsWith('en-') || normalized.startsWith('en_')) {
    return 'en';
  }
  return 'zh';
}

/**
 * 优先用显式 locale；否则读 OD 持久化语言；再否则按 `<html lang>` / 路径推断。
 */
export function resolveBridgeLocale(locale?: BridgeLocale): BridgeLocale {
  if (locale === 'en' || locale === 'zh') return locale;
  if (typeof window === 'undefined') return 'zh';
  try {
    const stored = window.localStorage.getItem('open-design:locale');
    if (stored) return toBridgeLocale(stored);
  } catch {
    /* ignore */
  }
  const htmlLang = document.documentElement.getAttribute('lang');
  if (htmlLang) return toBridgeLocale(htmlLang);
  return window.location.pathname.includes('/en') ? 'en' : 'zh';
}

export function bridgeCopy(locale: BridgeLocale | undefined, zh: string, en: string): string {
  return resolveBridgeLocale(locale) === 'en' ? en : zh;
}

/** saveImage 等共用错误文案 */
export function saveBridgeError(
  kind: 'timeout' | 'failed' | 'callFailed',
  locale?: BridgeLocale,
): string {
  switch (kind) {
    case 'timeout':
      return bridgeCopy(locale, '保存超时，请重试', 'Save timed out. Please try again.');
    case 'failed':
      return bridgeCopy(locale, '保存失败', 'Save failed');
    case 'callFailed':
      return bridgeCopy(locale, 'Bridge 调用失败', 'Bridge call failed');
  }
}
